import { createContext, useContext } from 'react';

export const VisibilityObserverRootContext = createContext<HTMLElement | null>(null);

export type UseVisibilityObserverRootContext = () => HTMLElement | null;
export const useVisibilityObserverRootContext: UseVisibilityObserverRootContext = () =>
  useContext(VisibilityObserverRootContext);
